<template>
<div v-if="store.removeCommentShow" class="custom-modal active" @click.self="store.hideRemoveModal()">
<div class="custom-modal-content w-640">
    <div class="share-header">
        <span>Видалити коментар</span>
        <div class="custom-modal-close" @click="store.hideRemoveModal()">
            <icon-modal-close/>
        </div>
    </div>
    <p>Ви дійсно бажаєте видалити коментар? <br> Цю дію неможливо буде відмінити. </p>
    <div class="test-comment test-comment-removed">
        <div class="test-comment-avatar" :class="{'no-avatar': !store.removeCommentData.avatar}">
            <img :src="store.removeCommentData.avatar" :alt="store.removeCommentData.author" v-if="store.removeCommentData.avatar">
            <icon-user v-else/>
        </div>
        <div class="test-comment-main">
            <div class="test-comment-header flex-v-center">
                <div class="flex-v-center test-comment-header-content">
                    <div class="test-comment-author">{{ store.removeCommentData.author }}</div>
                    <div class="test-comment-date"> {{ timeAgo(store.removeCommentData.created_at) }}</div>
                </div>
            </div>
            <div class="test-comment-text" v-html="store.removeCommentData.comment"></div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline" @click="store.hideRemoveModal()">Відмінити</button>
        <button class="btn btn-main" @click="store.removeComment(store.removeCommentData.id)">Видалити</button>
    </div>
</div>
</div>
</template>
<script>
import IconUser from '../../icons/IconUser.vue';
import IconModalClose from '../../icons/IconModalClose.vue';
import {tourniquetStore} from '../../../store/store';
import {timeAgo} from '../../helpers/helperFunctions';

export default {
    components: {IconModalClose, IconUser},
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    mixins: [timeAgo()],
    methods: {
        timeAgo
    }
}
</script>
